export const STOCK_LOCATION = 'StockLocation';
export const StockLocationKindValues = [
    'physical',
    'in-transit',
    'third-party',
    'virtual',
];
/** pt-BR labels for {@link StockLocationKind}. */
export const STOCK_LOCATION_KIND_LABELS = {
    physical: 'Físico',
    'in-transit': 'Em trânsito',
    'third-party': 'Terceiros',
    virtual: 'Virtual',
};
//# sourceMappingURL=stock-location.js.map